function firstOrDefault<T>(data: T[], cb?: boolCallback<T>): T | undefined {
    if (!Array.isArray(data)) return data;
    if (!data.length) return;
    if (!cb) return data[0];
    for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (cb(element)) return element
    }
    return undefined;
}


function isNullOrEmpty(data: Array<any>): boolean {
    return !data || !data.length
}

function arrSum(v: number[]): number;
// function arrSum<T>(v: [], cb: numberCallback<T>): number;
function arrSum<T = any>(v: T[] | number[], cb?: numberCallback<T>): number {
    var arr = v as Array<any>;
    if (Array.isNullOrEmpty(arr)) return 0;
    if (cb) arr = arr.map(cb);
    return arr.reduce((a, b) => a + b, 0);
}


Array.firstOrDefault = firstOrDefault
Array.isNullOrEmpty = isNullOrEmpty
Array.sum = arrSum
